import React from 'react';
import TituloTexto from '../../layout/titulo-texto';

const PagoAgencia = () => {
  const texto = 'Para confirmar tu reserva debes realizar el pago de forma presencial o coordinarlo con un asesor la reserva parmanecera activa por 72 hs una vez transcurrido ese tiempo la misma'
        + ' sera cancelada automaticamente.';
  return (
    <TituloTexto titulo='Elegiste pagar en la agencia' texto={texto} />
  );
};

export default PagoAgencia;
